export const QUICKSHOP_MODAL = 'quickshop.j2';

export const LOAD_QUICKSHOP = 'LOAD_QUICKSHOP';
export const CLOSE_QUICKSHOP = 'CLOSE_QUICKSHOP';
export const NEXT_QUICKSHOP_PRODUCT = 'NEXT_QUICKSHOP_PRODUCT';
export const PREVIOUS_QUICKSHOP_PRODUCT = 'PREVIOUS_QUICKSHOP_PRODUCT';
export const SAVE_QUICKSHOP_ITEM = 'SAVE_QUICKSHOP_ITEM';
export const QUICKSHOP_SAGAS_INITIALIZED = 'QUICKSHOP_SAGAS_INITIALIZED';
